export default "__VITE_ASSET__804d94b7__"